import { useAppSelector } from 'hooks/reduxHooks'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import useDoublePointsCampaignTier from '../hooks/useDoublePointsCampaignTier'

const TitleContainer = styled.div`
  &.platinum {
    color: ${props => props.theme.palette.neutral.default.eight};
  }
`

function DoublePointTakeoverTitleContent() {
  const loyaltyProgramName = getLoyaltyProgramDisplayName()
  const [tier, tierName, , nextTierName] = useCurrentLoyaltyTier()
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)
  const displayTier = useDoublePointsCampaignTier()
  const displayTierName = nextTierName ?? tierName

  const displayText = useMemo(() => {
    if (hasLoyaltyAccount) {
      if (tier === 'platinum') {
        return <>Extend your <i>{displayTierName}</i> {loyaltyProgramName} status</>
      }
      return <>Fast-track your <i>{displayTierName}</i> {loyaltyProgramName} status</>
    }

    return `Fast-track your ${loyaltyProgramName} status`
  }, [hasLoyaltyAccount, displayTierName, loyaltyProgramName, tier])

  return (
    <TitleContainer className={displayTier}>
      {displayText}
    </TitleContainer>
  )
}

export default DoublePointTakeoverTitleContent
